export type FaqAnswerPart = string | { href: string; label: string };

export interface HomeFaqItem {
  question: string;
  answerParts: readonly FaqAnswerPart[];
}

export const HOME_FAQS: readonly HomeFaqItem[] = [
  {
    question: "Are Uma's Aura crystals and spiritual products authentic?",
    answerParts: [
      "We describe each product's material and features on its product page. Because natural crystals and gemstones are formed individually, colour, pattern, texture and size can vary slightly from the photographs; these natural differences are part of each piece's character.",
    ],
  },
  {
    question: "How do I choose the right crystal, bracelet, rudraksha or mala?",
    answerParts: [
      "Begin with your purpose, preferred material and the practical details listed on each product page. You can compare categories and read the product guidance before ordering. If you are unsure, ",
      { href: "/contact-us", label: "contact our team" },
      " for help understanding the available options.",
    ],
  },
  {
    question: "How should I cleanse and care for my purchase?",
    answerParts: [
      "Follow the care or wearing guidance shown on the individual product page. As a general precaution, store pieces separately, wipe them gently with a soft dry cloth and avoid harsh chemicals, perfumes or prolonged water exposure unless the product instructions say otherwise.",
    ],
  },
  {
    question: "When will my order be delivered?",
    answerParts: [
      "Orders are generally processed and shipped within 5–7 business days. Delivery estimates after dispatch depend on your location and courier serviceability, and may change during festivals or unforeseen delays. Tracking information is shared after dispatch. Read the full ",
      { href: "/shipping-policy", label: "Shipping Policy" },
      ".",
    ],
  },
  {
    question: "Can I return or replace a product?",
    answerParts: [
      "Eligible unused products may be requested for return within 7 days of delivery when they are in their original condition and packaging. Personalised items and products marked non-returnable are excluded. Please review the ",
      { href: "/cancellation-refunds", label: "Cancellation and Refunds Policy" },
      " for the complete conditions.",
    ],
  },
  {
    question: "What should I do if an item arrives damaged or incorrect?",
    answerParts: [
      { href: "/contact-us", label: "Contact us" },
      " promptly with your order number and clear photographs of the product and packaging. Our team will review the issue and arrange the applicable replacement or refund in line with our published policy.",
    ],
  },
  {
    question: "Do these products or consultations replace professional advice?",
    answerParts: [
      "No. Spiritual products and astrology guidance are intended for personal and cultural use. They do not diagnose, treat or prevent medical conditions and should not replace advice from qualified medical, legal or financial professionals.",
    ],
  },
];

export const getFaqAnswerText = (faq: HomeFaqItem) =>
  faq.answerParts
    .map((part) => (typeof part === "string" ? part : part.label))
    .join("");
